import { Box, IconButton, Tooltip } from '@mui/material'
import { FC } from 'react'
import EngagementReviewPauseIcon from '../../../../assets/images/icons/engagement-review-pause-icon.svg?react'
import EngagementReviewPlayIcon from '../../../../assets/images/icons/engagement-review-play-icon.svg?react'
import WarningIcon from '@mui/icons-material/Warning'

interface PlayPauseButtonProps {
  isPlaying: boolean
  isBuffering?: boolean
  errorMessage?: string
  onClick: () => void
}

export const PlayPauseButton: FC<PlayPauseButtonProps> = ({ isPlaying, isBuffering = false, errorMessage, onClick }) => {
  return (
    <Tooltip title={errorMessage}>
      <Box sx={{ position: 'relative', mr: 'var(--spacing-s)' }}>
        <IconButton
          onClick={onClick}
          loading={isBuffering}
          size="small"
          aria-label={isPlaying ? 'Pause' : 'Play'}
          data-testid={isPlaying ? 'ert-player-controls-pause-button' : 'ert-player-controls-play-button'}
        >
          {isPlaying ? <EngagementReviewPauseIcon /> : <EngagementReviewPlayIcon />}
        </IconButton>
        {errorMessage && (
          <WarningIcon
            sx={{
              color: 'var(--text-disabled)',
              position: 'absolute',
              bottom: 0,
              right: 0,
              height: '45%',
              width: '45%',
              backgroundColor: 'var(--white-70)',
              borderRadius: '50%',
              boxShadow: '0 0 2px 2px var(--white-70)',
              pointerEvents: 'none'
            }}
          />
        )}
      </Box>
    </Tooltip>
  )
}
